/* =============================================
   TIN SIGN SHOP — THEME JS
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  // --- MOBILE NAV ---
  const navToggle = document.querySelector('.nav-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileOverlay = document.querySelector('.mobile-nav-overlay');
  const mobileClose = document.querySelector('.mobile-nav-close');

  function openMobileNav() {
    mobileNav && mobileNav.classList.add('open');
    mobileOverlay && (mobileOverlay.style.display = 'block');
    navToggle && navToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    mobileNav && mobileNav.classList.remove('open');
    mobileOverlay && (mobileOverlay.style.display = 'none');
    navToggle && navToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  navToggle && navToggle.addEventListener('click', openMobileNav);
  mobileClose && mobileClose.addEventListener('click', closeMobileNav);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobileNav);

  // Mobile sub-menus
  document.querySelectorAll('.mobile-sub-toggle').forEach(btn => {
    btn.addEventListener('click', function () {
      const sub = this.nextElementSibling;
      const isOpen = sub && sub.classList.contains('open');
      document.querySelectorAll('.mobile-sub').forEach(s => s.classList.remove('open'));
      if (!isOpen && sub) sub.classList.add('open');
      this.querySelector('span').textContent = isOpen ? '+' : '−';
    });
  });

  // --- SEARCH TOGGLE ---
  const searchToggle = document.querySelector('.search-toggle');
  const searchBar = document.querySelector('.search-bar');
  const searchClose = document.querySelector('.search-close');
  const searchInput = searchBar && searchBar.querySelector('input');

  searchToggle && searchToggle.addEventListener('click', function () {
    const hidden = searchBar.hasAttribute('hidden');
    if (hidden) {
      searchBar.removeAttribute('hidden');
      searchInput && searchInput.focus();
    } else {
      searchBar.setAttribute('hidden', '');
    }
  });
  searchClose && searchClose.addEventListener('click', function () {
    searchBar && searchBar.setAttribute('hidden', '');
  });

  // --- PRODUCT GALLERY ---
  const galleryMain = document.getElementById('gallery-main');
  const slides = galleryMain ? galleryMain.querySelectorAll('.gallery-slide') : [];
  const thumbs = document.querySelectorAll('.gallery-thumb');

  function showSlide(index) {
    slides.forEach(s => s.classList.remove('active'));
    thumbs.forEach(t => t.classList.remove('active'));
    if (slides[index]) slides[index].classList.add('active');
    if (thumbs[index]) thumbs[index].classList.add('active');
  }

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function () {
      showSlide(parseInt(this.dataset.index));
    });
  });

  // --- QTY CONTROLS (product page) ---
  const qtyInput = document.getElementById('quantity');
  if (qtyInput) {
    document.querySelectorAll('.product-info .qty-btn').forEach(btn => {
      btn.addEventListener('click', function () {
        let val = parseInt(qtyInput.value) || 1;
        if (this.dataset.action === 'plus') val++;
        if (this.dataset.action === 'minus' && val > 1) val--;
        qtyInput.value = val;
      });
    });
  }

  // --- VARIANT SELECTOR ---
  // Finds the variant matching the chosen options and puts its ID in the form,
  // so the size/style the customer picks is what goes in the cart.
  const variantSelect = document.querySelectorAll('.option-select[data-option-index]');
  const variantIdInput = document.getElementById('variant-id');
  const addToCartBtn = document.querySelector('.btn-add-to-cart');
  const buyNowBtn = document.querySelector('.btn-buy-now');
  const priceEl = document.getElementById('product-price');
  const compareEl = document.getElementById('price-compare');
  const productJsonEl = document.getElementById('product-json');
  let productData = null;
  try { productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null; } catch (e) { productData = null; }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateVariant() {
    if (!productData || !variantIdInput) return;
    const selected = Array.from(variantSelect).map(s => s.value);
    const match = productData.variants.find(v =>
      v.options.every((opt, i) => opt === selected[i])
    );

    if (!match) {
      if (addToCartBtn) { addToCartBtn.disabled = true; addToCartBtn.textContent = 'Unavailable'; }
      if (buyNowBtn) buyNowBtn.disabled = true;
      return;
    }

    variantIdInput.value = match.id;

    if (priceEl) priceEl.textContent = formatMoney(match.price);
    if (compareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareEl.textContent = formatMoney(match.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (addToCartBtn) {
      addToCartBtn.disabled = !match.available;
      addToCartBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
    }
    if (buyNowBtn) buyNowBtn.disabled = !match.available;

    // Show the variant's own photo if it has one
    if (match.featured_image && productData.images) {
      const idx = productData.images.findIndex(src => src.split('?')[0].endsWith(match.featured_image.src.split('?')[0].split('/').pop()));
      if (idx > -1) showSlide(idx);
    }

    // Keep the URL in sync so refresh/share keeps the chosen size
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* ignore */ }
  }

  if (variantSelect.length && variantIdInput) {
    variantSelect.forEach(sel => sel.addEventListener('change', updateVariant));
    updateVariant();
  }

  // --- QUICK ADD TO CART (AJAX) ---
  document.querySelectorAll('.product-grid .quick-add-btn').forEach(btn => {
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      const form = this.closest('form');
      if (!form) return;
      const id = form.querySelector('[name="id"]').value;
      this.textContent = 'Adding…';
      this.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id, quantity: 1 })
        });
        if (res.ok) {
          this.textContent = '✓ Added!';
          updateCartCount();
          setTimeout(() => {
            this.textContent = 'Quick Add';
            this.disabled = false;
          }, 1800);
        } else {
          this.textContent = 'Error';
          this.disabled = false;
        }
      } catch {
        this.textContent = 'Error';
        this.disabled = false;
      }
    });
  });

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const badge = document.querySelector('.cart-count');
      if (cart.item_count > 0) {
        if (badge) {
          badge.textContent = cart.item_count;
        } else {
          const cartLink = document.querySelector('.cart-link');
          if (cartLink) {
            const span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = cart.item_count;
            cartLink.appendChild(span);
          }
        }
      }
    } catch (e) { /* silent */ }
  }

  // --- CART PAGE QTY & REMOVE ---
  document.querySelectorAll('.cart-page .qty-btn').forEach(btn => {
    btn.addEventListener('click', async function () {
      const key = this.dataset.key;
      const input = document.querySelector(`.cart-qty-input[data-key="${key}"]`);
      if (!input) return;
      let qty = parseInt(input.value) || 1;
      if (this.dataset.action === 'plus') qty++;
      if (this.dataset.action === 'minus') qty = Math.max(0, qty - 1);
      input.value = qty;
      await updateCartItem(key, qty);
    });
  });

  document.querySelectorAll('.cart-remove').forEach(btn => {
    btn.addEventListener('click', async function () {
      const key = this.dataset.key;
      await updateCartItem(key, 0);
      const item = this.closest('.cart-item');
      if (item) item.remove();
      updateCartCount();
    });
  });

  async function updateCartItem(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      updateCartCount();
    } catch (e) { /* silent */ }
  }

  // --- STICKY HEADER SHADOW ---
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 10
        ? '0 4px 20px rgba(0,0,0,0.5)'
        : '0 2px 12px rgba(0,0,0,0.4)';
    }, { passive: true });
  }

  // --- SCROLL REVEAL (simple fade-in) ---
  const revealEls = document.querySelectorAll(
    '.product-card, .collection-card, .testimonial-card, .brand-story-inner, .trust-item'
  );
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }

});
